<template lang="pug">
<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.85352 4.35254C6.53981 4.35254 3.85352 7.03883 3.85352 10.3525C3.85352 13.6662 6.53981 16.3525 9.85352 16.3525C13.1672 16.3525 15.8535 13.6662 15.8535 10.3525C15.8535 7.03883 13.1672 4.35254 9.85352 4.35254ZM1.85352 10.3525C1.85352 5.93426 5.43524 2.35254 9.85352 2.35254C14.2718 2.35254 17.8535 5.93426 17.8535 10.3525C17.8535 12.2015 17.2263 13.904 16.1729 15.2587L21.7522 20.838L20.338 22.2522L14.7586 16.6728C13.404 17.7256 11.702 18.3525 9.85352 18.3525C5.43524 18.3525 1.85352 14.7708 1.85352 10.3525Z" fill="#141414"/></svg>

</template>

<style lang="stylus" scoped>

</style>

<script>
export default {

}
</script>
